import React from "react";
import {
  ArticlesContainer,
  ArticlesList,
  ContentInfoWrap,
  Heading3,
  ItemContainer,
  ItemContentWrap,
  ItemImageWrap,
  PopoverWrap,
  Label,
  LabelBold,
  ListItem,
  PopoverContent,
  PopoverTitle,
  Button,
  ButtonGroupVertical,
} from "./article-list.style";
import { firebaseDB } from "../firebaseConfig";
import { remove, ref, get, set } from "firebase/database";
import { MdDeleteForever, MdEditSquare } from "react-icons/md";

const db = firebaseDB;

const ArticleList = ({ articles, onEditArticle, setOnEditArticle }) => {

  const sortedArticles = articles.sort((a, b) => b.id - a.id);

  const deleteArticle = async (magazine, articleId) => {
    if (window.confirm("Möchtest du diesen Artikel löschen?")) {
      const articleRef = ref(db, `articles/${magazine}/${articleId}`);
      try {
        await remove(articleRef)
          .then(() => console.log("Article Deleted"))
          .catch((error) => console.log(error));

        // Lade die gesamte Keywords-Tabelle für das Magazin
        const keywordsRef = ref(db, `keywords/${magazine}`);
        const snapshot = await get(keywordsRef);
        if (snapshot.exists()) {
          const keywordsData = snapshot.val();

          // Durchlaufe alle Keywords, um die Artikel-ID zu entfernen
          for (const [keyword, articleIds] of Object.entries(keywordsData)) {
            if (articleIds.includes(articleId.toString())) {
              const updatedArticleIds = articleIds.filter(id => id !== articleId.toString());
              // Update nur, wenn es noch Artikel-IDs gibt, sonst entferne das Keyword
              if (updatedArticleIds.length > 0) {
                await set(ref(db, `keywords/${magazine}/${keyword}`), updatedArticleIds);
              } else {
                await remove(ref(db, `keywords/${magazine}/${keyword}`));
              }
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleEditClick = (article) => {
    onEditArticle(article);
  };

  return (
    <ArticlesContainer>
      <h2 style={{ margin: "0 0 .75em 0" }}>Artikel Datenbank</h2>
      <Label>Gesamtanzahl: {articles.length}</Label>
      <ArticlesList>
        {sortedArticles.map((article, index) =>
          article ? (
            <ListItem key={index}>
              <PopoverWrap>
                <ItemContainer>
                  <ItemImageWrap>
                    <img
                      src={article.content[0].url}
                      width={64}
                      height={64}
                      alt={article.content[0].url}
                    />
                  </ItemImageWrap>
                  <ItemContentWrap>
                    <Label>{article.id}</Label>
                    <Heading3>{article.headline}</Heading3>
                    <ContentInfoWrap>
                      <Label>{article.magazine}</Label>
                      <LabelBold>
                        {new Date(article.datePublished).toLocaleDateString()}
                      </LabelBold>
                    </ContentInfoWrap>
                  </ItemContentWrap>
                  <ButtonGroupVertical>
                    <Button onClick={() => handleEditClick(article)}>
                      <MdEditSquare />
                    </Button>
                    <Button
                      onClick={() =>
                        deleteArticle(article.magazine, article.id)
                      }
                    >
                      <MdDeleteForever />
                    </Button>
                  </ButtonGroupVertical>
                </ItemContainer>
                <PopoverContent className="popover-content">
                  <PopoverTitle>{article.headline}</PopoverTitle>
                  <p style={{ fontSize: "0.85em" }}>{article.description}</p>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: ".5em",
                    }}
                  >
                    <LabelBold>
                      {"Veröffentlichung: " +
                        new Date(article.datePublished).toLocaleDateString()}
                    </LabelBold>
                    <LabelBold>
                      {"Zuletzt geändert: " +
                        new Date(article.dateModified).toLocaleDateString()}
                    </LabelBold>
                  </div>
                </PopoverContent>
              </PopoverWrap>
            </ListItem>
          ) : null,
        )}
      </ArticlesList>
    </ArticlesContainer>
  );
};

export default ArticleList;
